import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => <Outlet />,
  notFoundComponent: NotFound,
});

function NotFound() {
  const { t } = useTranslation();
  return <p className="p-8 text-ink-3">{t('errors.NOT_FOUND')}</p>;
}
